import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry && !original.url.includes("/auth/")) {
      original._retry = true;
      try {
        await api.post("/auth/refresh");
        return api(original);
      } catch {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export const fileUrl = (u, w) => {
  if (!u) return "";
  const url = u.startsWith("http") ? u : `${API}/files/${u.replace(/^\/api\/files\//, "")}`;
  if (w && url.includes("images.unsplash.com")) {
    return `${url}${url.includes("?") ? "&" : "?"}auto=format&fit=crop&w=${w}&q=70`;
  }
  return url;
};

export const isVideo = (u) => /\.(mp4|webm|mov)(\?|#|$)/i.test(u || "");

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).filter(Boolean).join(" ");
  return "Algo deu errado. Tente novamente.";
};
